import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Resolve an image reference to a loadable URL.
// - absolute http(s) → as-is
// - /api/... (uploaded file) → backend origin + path
// - /assets/... (static) → as-is (served by frontend)
export const imgSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};
